export const paths = {
  home: '/',
  login: '/login',
  products: '/products'
}
